<template>
  <div class="suite-of-power">
    <FormattedHeader :header="title" :subheader="subtitle" />
    <div
      class="lg:max-w-5xl grid grid-cols-9 justify-items-center gap-2 mx-auto px-8"
    >
      <div
        v-for="(block, index) in features"
        :key="`suite-block-${index}`"
        class="max-w-xs col-span-9 md:col-span-3 m-2"
        :full-bleed="true"
      >
        <div class="flex flex-col items-center text-black text-center p-6">
          <figure class="image mb-3 mt-2">
            <FontAwesomeIcon
              :icon="block.icon"
              class="text-primary icon w-10 h-10"
            />
          </figure>
          <TypeHeading
            :variant="$options.Typography.Heading.HEADLINE"
            :weight="$options.Typography.Weights.BOLD"
          >
            <p class="mb-2">{{ block.heading }}</p>
          </TypeHeading>
          <TypeBody
            :variant="$options.Typography.Body.TEXT"
            :weight="$options.Typography.Weights.REGULAR"
          >
            <p class="max-w-xs mx-auto" v-html="block.subheading"></p>
          </TypeBody>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constants, TypeBody, TypeHeading } from '@bambeehr/pollen';
import { defineComponent } from '@nuxtjs/composition-api';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBullseyeArrow, faSatellite } from '@fortawesome/pro-light-svg-icons';
import { faRobot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FormattedHeader from '@/components/FormattedHeader.vue';

library.add(faBullseyeArrow);
library.add(faSatellite);
library.add(faRobot);

const { Typography } = constants;
export default defineComponent({
  name: 'LowPrices',
  Typography,
  components: {
    TypeBody,
    TypeHeading,
    FontAwesomeIcon,
    FormattedHeader,
  },
  setup() {
    const title = `How We Keep Prices So Low`;
    const subtitle = `And keep quality high`;
    const features = [
      {
        image: '/assets/information/reviews/target.svg',
        icon: ['fal', 'bullseye-arrow'],
        heading: 'Small Business Focused',
        subheading:
          "We only service businesses with less than 500 employees so that our staff isn't spread too thin.",
      },
      {
        image: '/assets/information/reviews/satelite.svg',
        icon: ['fal', 'satellite'],
        heading: 'Cutting Edge Tech',
        subheading:
          'We use cutting edge data technology to stay informed about labor laws & help you avoid mistakes.',
      },
      {
        image: '/assets/information/reviews/robot.svg',
        icon: ['fas', 'robot'],
        heading: 'Service Automation',
        subheading:
          'We invest in automation to increase the accuracy, quality and efficiency of all the HR work to do.',
      },
    ];

    return {
      title,
      subtitle,
      features,
    };
  },
});
</script>
